import constants from '../utils/constants.js';
import SessionStore from '../stores/SessionStore.js'
import useStores from './useStores.js';
import NoteStore from '../stores/NoteStore.js';

import Header from './Header.js';

const {GAME_LENGTH} = constants;

function PageNote() {
  useStores([SessionStore]);

  const practice = SessionStore.getPractice();
  const scale = NoteStore.getScaleNr();
  const useRandomScales = NoteStore.useRandomScales();

  return (
    <>
      <Header />

      <div className="middle">
        <p>
          You are about to start on a series of flash cards with the
          goal to determine the note (A through G) displayed on each
          card.
        </p>
        <p>
          You will get {GAME_LENGTH} cards that you
          need to answer. Your score is the time it takes you to answer
          all of them correctly, with one penalty second added for each
          wrong answer. The lower your score, the better you did.
        </p>
        <p>
          <b>Type of practice:</b><br/>
          <label
            onClick={() => SessionStore.setPractice('name')}
          >
            <input
              type="radio"
              name="practice"
              value="name"
              checked={practice === 'name'}
            /> Note names
          </label><br/>
          <label
            onClick={() => SessionStore.setPractice('position')}
          >
            <input
              type="radio"
              name="practice"
              value="position"
              checked={practice === 'position'}
            /> Finger positions</label>
        </p>

        {
          // for now, scales are only support with note names
          practice === 'name' &&
          (
            <p>
              <b>Scales to use:</b><br/>
              <label
                onClick={() => NoteStore.setScaleNr(0)}
              >
                <input
                  type="radio"
                  name="scale"
                  value="0"
                  checked={!useRandomScales && scale === 0}
                /> C Major
              </label><br/>
              <label
                onClick={() => NoteStore.setScaleNr(2)}
              >
                <input
                  type="radio"
                  name="scale"
                  value="0"
                  checked={!useRandomScales && scale === 2}
                /> D Major
              </label><br/>
              <label
                onClick={() => NoteStore.setScaleNr(14)}
              >
                <input
                  type="radio"
                  name="scale"
                  value="0"
                  checked={!useRandomScales && scale === 14}
                /> F Major
              </label><br/>
              ...<br/>
              <label
                onClick={() => NoteStore.setUseRandomScales()}
              >
                <input
                  type="radio"
                  name="scale"
                  value="0"
                  checked={useRandomScales}
                /> Random Scale
              </label>
            </p>
          )
        }
      </div>

      <div className="bottom">
        <div class="buttons">
          <button
            onClick={() => {
              SessionStore.startGame();
            }}
          >
            Start the Game
          </button>
        </div>
      </div>
    </>
  );
}

export default PageNote;
